import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Select from '../../../components/ui/Select';
import Input from '../../../components/ui/Input';

const StatusUpdateModal = ({ order, onClose, onUpdate }) => {
  const [selectedStatus, setSelectedStatus] = useState(order?.status || '');
  const [notes, setNotes] = useState('');
  const [sendNotification, setSendNotification] = useState(true);

  const statusOptions = [
    { value: '주문 접수', label: '주문 접수' },
    { value: '주문완료', label: '주문완료' },
    { value: '픽업 예정', label: '픽업 예정' },
    { value: '세탁 중', label: '세탁 중' },
    { value: '배송 예정', label: '배송 예정' },
    { value: '완료', label: '완료' }
  ];

  const handleSubmit = (e) => {
    e?.preventDefault();
    onUpdate({
      orderId: order?.id,
      status: selectedStatus,
      notes,
      sendNotification,
      timestamp: new Date()?.toISOString()
    });
    onClose();
  };

  if (!order) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4">
      <div className="w-full max-w-md rounded-lg bg-card shadow-xl">
        <div className="flex items-center justify-between border-b border-border px-6 py-4">
          <h2 className="text-xl font-bold text-foreground">상태 변경</h2>
          <button
            onClick={onClose}
            className="rounded-lg p-2 text-muted-foreground transition-colors duration-150 hover:bg-muted hover:text-foreground"
            aria-label="닫기"
          >
            <Icon name="X" size={20} />
          </button>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4 p-6">
          <div className="rounded-lg border border-border bg-muted/30 p-3">
            <p className="text-sm text-muted-foreground">주문번호</p>
            <p className="text-base font-semibold text-foreground">{order?.orderNumber}</p>
          </div>

          <Select
            label="새 상태"
            options={statusOptions}
            value={selectedStatus}
            onChange={setSelectedStatus}
            required
          />

          <Input
            label="메모 (선택사항)"
            type="text"
            placeholder="상태 변경 사유나 특이사항을 입력하세요"
            value={notes}
            onChange={(e) => setNotes(e?.target?.value)}
          />

          <div className="flex items-center space-x-2">
            <input
              type="checkbox"
              id="sendNotification"
              checked={sendNotification}
              onChange={(e) => setSendNotification(e?.target?.checked)}
              className="h-4 w-4 rounded border-border text-accent focus:ring-2 focus:ring-accent"
            />
            <label htmlFor="sendNotification" className="text-sm text-foreground">
              고객에게 카카오톡 알림 전송
            </label>
          </div>

          <div className="flex space-x-3 pt-4">
            <Button type="button" variant="outline" onClick={onClose} fullWidth>
              취소
            </Button>
            <Button type="submit" variant="default" fullWidth>
              변경하기
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default StatusUpdateModal;